import { defineQueryOptions } from '@pinia/colada';
import { api, ApiError } from './client.ts';
import type { components } from './schema.gen.ts';
import { messageOf } from './serverFailure.ts';

export type Feedback = components['schemas']['Feedback'];

export const feedbackKeys = {
  all: ['feedback'] as const,
};

const loginReturningHere = (login: string): string => {
  const url = new URL(login);
  url.searchParams.set('rd', window.location.href);
  return url.href;
};

export const feedbackListQuery = defineQueryOptions({
  key: feedbackKeys.all,
  query: async (): Promise<Feedback[]> => {
    const { data, response } = await api.GET('/feedback', { headers: { Accept: 'application/json' } });
    const login = response.headers.get('Location');
    if (!data && login) window.location.assign(loginReturningHere(login));
    if (!data) throw new ApiError(response.status);
    return data.feedback;
  },
});

export const leaveFeedback = async (feedback: string): Promise<void> => {
  const { error, response } = await api.PUT('/game/feedback', { body: { feedback } });
  if (error) throw new ApiError(response.status, messageOf('leaveFeedback', error), error.slug);
};
